import React from 'react';
import {SetupPage} from 'areas/shared/pages/setup';
import * as APIModules from 'modules/app/API';
import * as API from 'modules/app/API';
import * as Formatter from 'fw/components/formatter/Formatter';
import * as App from 'modules/app/App';
import Search from './Search';

class DiscountCodesHistoryTab extends React.Component {
    constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
            selectedId: null,
            sponsorHistoryId: null,
            loading: true,
			title: "",
			sponsorName: null,
            form: {},
			generateCodePrivilege: App.hasPrivilege("AdminDiscountCodeSetupGenerate")
        };
	}

    get = () => {
		API.Sponsor.get('/sponsorSetup/getSponsorInfo', { sponsorId: this.props.selectedId },
			{
				success: (r) => {
					this.setState((prevState, props) => ({
						loading: false,
						form: r.data,
                        title: r.data.title,
						sponsorName: r.data.sponsorName
					}));
				}
			});
	}

    componentDidMount() {
		if (!this.props.active)
			return;

		this.get();
	}

    loadRequest = (selectedId) => {
		return {
			sponsorId: selectedId,
		};
	}

	onGenerateDiscountCodePopUpClose = (success) => {
        this.setState({
            showGenerateDiscountCodePopUp: false
        }, () => { if (success === true) { this._setup.reload(); } });
    }

    onGenerateDiscountCodeClick = () => {
        this.setState({
            showGenerateDiscountCodePopUp: true
        });
    }
    
    render = () => {
		if (!this.props.active)
			return null;
		
		let opts = {
			setupKey: "discountCodeGeneration",
			title: "Certification Support History - " + this.state.sponsorName,
			description: "",
			enableColumnSettings: true,
			enableExport: false,
			disableSelect: true,
			searchProps: {
				sponsorId: this.props.selectedId,
				sponsorName: this.state.sponsorName
			},
			list: {
				url: APIModules.Sponsor.url('/sponsorSetup/searchDiscountCodesHistory'),
				rowKey: 'discountCodeGenerationId',
                columns: [
                    { key: 'invoiceNumber', name: 'INV', width: 60 },
                    { key: 'invoiceDescription', name: 'Description' },
					{ key: 'invoiceDate', name: 'INV Date', formatter: Formatter.Date, width: 140 },
					{ key: 'datePaid', name: 'Date Paid', formatter: Formatter.Date, width: 140 },
					{ key: 'issued', name: 'Issued' },
					{ key: 'used', name: 'Used' },
                    { key: 'beginningBalance', name: 'Beg. Balance', formatter: Formatter.Currency, width: 140 },
                    { key: 'endBalance', name: 'End. Balance', formatter: Formatter.Currency, width: 140 }
                ]
			},
			tabs: [
                
            ]
		};

		return (
			<SetupPage {...opts}
					Search={Search} />
		);
	}
}

export default DiscountCodesHistoryTab;


// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/discountCodesHistory/DiscountCodesHistoryTab.js